export default __webpack_public_path__ + "static/media/6.28e20d14.jpg";